/**
 *
 */




class BaraZoroFactory extends CategFactorable {

	constructor(resultData, or34, spaceAllFact) {
		super(resultData, or34, spaceAllFact);

		this._spaceAllFact = spaceAllFact;

		this._STR = [ ['bara','zoro','3card'], ['bara', 'zoro', '2p','3card', '4card'] ];
		this._NUM = [ [30,20,10], [40, 30, 22, 23, 10] ];
		this._str = this._STR[this._or34-3];
		this._num = this._NUM[this._or34-3];


		this._baraZoro = this.makeArray(this._spaceAllFact.spaceAllArr, this._nbSort);
		this._baraZoroDef = this.makeArray( this._spaceAllFact.spaceAllDefArr, this.sortArrayUint8( this._nbDef ));
		this._baraZoroDefDup = this.makeArray(this._spaceAllFact.spaceAllDefDupArr, this._nbDefDup);
		this._baZoPercent = this.makeCountArray(this._baraZoroDef);


	};

	get str() {   return this._str;   };
	get num() {   return this._num;   };


	get baraZoro() {   return this._baraZoro;   };
	get baraZoroDef() {   return this._baraZoroDef;   };
	get baraZoroDefDup() {   return this._baraZoroDefDup;   };
	get baZoPercent() {   return this._baZoPercent;   };





	makeArray( spaceAll, nbSort ) {

		if(arguments.length!==2) {
			throw new Error('引数が不正です( 引数の数 )');
		}else {
			if(!(spaceAll instanceof Array) || !(spaceAll[0] instanceof Uint8Array || spaceAll[0] instanceof Array)) {
				throw new Error('引数が不正です(  第一引数が二次元配列ではありません  )');
			}

			if(!(nbSort instanceof Array) || !(nbSort[0] instanceof Uint8Array || nbSort[0] instanceof Array) || nbSort[0].length !==this._or34) {
				throw new Error('引数が不正です(  第二引数が二次元配列でないか２次要素数が違います  )');
			}else {
				if(nbSort.length<5) {
					throw new Error('第二引数の配列１次要素数がが５未満です');
				};

				let boo = false;

				for(let n=nbSort.length, i=n-5; i<n; i++) {
					if( nbSort[i].some(function(val, ind, arr) {
						let indRt = 0;
						if(ind-1 >= 0) {  indRt = ind-1;  };
						return (val - arr[indRt]) < 0    }) ) {
						boo = true;
						break;
					};
				};
				if(boo) {
					throw new Error('第二引数が不正です( 配列が昇順ではありません )');
				}
			};
		}

		let baraZoro = [];
		for(let i=0, n=spaceAll.length; i<n; i++) {
			let ct = 0;
			for(let j=0, n=spaceAll[i].length; j<n; j++) {
				ct+=spaceAll[i][j];
			};
			this._makeArraySub( baraZoro, ct, nbSort, i );
		};
		return baraZoro;
	};
	_makeArraySub( baraZoro, ct, sort, index ) {
		if(this._or34===4 && ct===8) {
			let boo = false;
			let ct2 = 0;
			for(let j=0, m=sort[index].length-1; j<m; j++) {
				if(sort[index][j]!==sort[index][j+1]) {   ct2 = j;   };
			};
			baraZoro.push(20+((ct2+1)%2+2));
		}else {
			baraZoro.push((10-ct)*10);
		};
	};


	makeCountArray(baZoDef) {
		let bzCt = MyUtility.makeFillArray( this._num.length, 0);
		this.sarchCount(baZoDef, this._num, bzCt);
		return bzCt;
	};


	//
	//  makeBooArray

	getMakeResultBooArray(bit1Arr, bit2Arr, plusNum, isSelect=true) {

		return this.getMakeBooArray( this._baraZoro, bit1Arr, isSelect);
	};

	getMakeDefBooArray(bit1Arr, bit2Arr, isDup=true, isSelect=true) {

		let target = this._baraZoroDef;
		if(! isDup) {   target = this._baraZoroDefDup;   };

		return this.getMakeBooArray(target, bit1Arr, isSelect);
	};

	getMakeBooArray(targetArr, bit1Arr, isSelect=true) {

		let isSelectNum = 1;
		if(! isSelect) {   isSelectNum = 0;   };

		let result = new Uint8Array(targetArr.length);

		for(let i=0, n=targetArr.length; i<n; i++) {
			let count = 0;
			for(let j=0, m=bit1Arr.length; j<m; j++) {
				if(bit1Arr[j]===isSelectNum && this._num[j]===targetArr[i]) {
					result[i] = 1;
				};
			};
		};
		return result;

	};






};



